<template>
    <div class="layout-article-page">
        <slot name="header">
            <div class="uk-section uk-section-medium uk-text-center uk-background-muted page-header">
              <div class="uk-light uk-container uk-container-small uk-text-center">

                  <router-link :to="parent.link" v-if="parent" class="text-green"><label>{{parent.menuTitle}}</label></router-link>
                  <h1 class="uk-margin-small-top">{{page.title}}</h1>

                  <slot name="summary">
                      <p class="uk-text-lead" v-if="page.summary">{{page.summary}}</p>
                  </slot>

                  <slot name="subheader"></slot>

                  <div uk-spinner v-if="$apollo.loading"></div>
              </div>
            </div>
        </slot>

        <template v-if="!!readOneNewsroom">

            <div class="uk-flex uk-grid-collapse" uk-grid>

                <div class="uk-width-1-1 uk-width-2-3@l uk-background-white">

                    <div class="uk-section uk-section-default uk-background-lightest" v-if="!!readOneNewsroom.inTheNews">
                        <div class="uk-container">

                            <h2><b>In The News</b> <router-link to="/newsroom/in-the-news"><i uk-icon="arrow-right" /></router-link></h2>

                            <ArticleCard :article="article.node" v-for="article in readOneNewsroom.inTheNews.edges" :key="article.urlSegment" />

                        </div>

                    </div>

                    <div class="uk-section uk-section-default" v-if="!!readOneNewsroom.pressReleases">
                        <div class="uk-container">

                            <h2><b>Press Releases</b> <router-link to="/newsroom/press-releases"><i uk-icon="arrow-right" /></router-link></h2>

                            <ArticleCard :article="article.node" v-for="article in readOneNewsroom.pressReleases.edges" :key="article.urlSegment" />

                        </div>

                    </div>

                    <div class="uk-section uk-section-default uk-background-lightest" v-if="!!readOneNewsroom.photoAlbums">
                        <div class="uk-container">

                            <h2><b>Photos</b> <router-link to="/newsroom/photos"><i uk-icon="arrow-right" /></router-link></h2>

                            <div class="uk-grid  uk-child-width-1-2@s uk-child-width-1-3@m" uk-grid uk-height-match="target: > .uk-card-title">
                                <div v-for="album in readOneNewsroom.photoAlbums.edges" :key="album.urlSegment">
                                    <PhotoAlbumCard :photoAlbum="album.node"  />
                                </div>
                            </div>

                        </div>

                    </div>

                    <div class="uk-section uk-section-default" v-if="!!readOneNewsroom.videos">
                        <div class="uk-container">

                            <h2><b>Videos</b> <router-link to="/newsroom/videos"><i uk-icon="arrow-right" /></router-link></h2>

                            <div class="uk-grid  uk-child-width-1-2@s uk-child-width-1-3@m" uk-grid uk-height-match="target: .uk-card-title">
                                <div v-for="video in readOneNewsroom.videos.edges" :key="video.urlSegment">
                                    <VideoCard :video="video.node"  />
                                </div>
                            </div>

                        </div>

                    </div>


                    <div class="uk-section uk-section-default" v-if="!!readOneNewsroom.interviews">
                        <div class="uk-container">

                            <h2><b>Interviews</b></h2>

                            <ArticleCard :article="article.node" v-for="article in readOneNewsroom.interviews.edges" :key="article.urlSegment" />

                            <router-link to="/newsroom/interviews">See all Interviews</router-link>

                        </div>

                    </div>



                </div>
                <div class="uk-tile uk-width-1-1 uk-width-1-3@l uk-backround-lightest-adjust uk-position-relative">
                    <h2><b>Social Media</b></h2>
                    <iframe src="https://widget.taggbox.com/10572" style="width:100%;height:100%;border:none;"></iframe>
                </div>
            </div>

        </template>
    </div>
</template>
<script>
import ArticleCard from '../articles/ArticleCard.vue'
import VideoCard from '../videos/VideoCard.vue'
import PhotoAlbumCard from '../photos/PhotoAlbumCard.vue'
import gql from 'graphql-tag'

// GraphQL query
const readNewsroomQuery = gql`
query ($url: String!) {
  readOneNewsroom(filter: { fullPath: { eq: $url }}) {
    title
    pressReleases(limit: 4) {
      edges {
        node {
            title
            link
            source
            created
            image {
                small
            }
        }
      }
    }
    inTheNews(limit: 4) {
      edges {
        node {
            title
            link
            source
            created
            image {
                small
            }
        }
      }
    }
    photoAlbums(limit: 8) {
      edges {
        node {
            created
           	title
            urlSegment
            link
            featuredImage {
                smallSquare
            }
        }
      }
    }
    videos(limit: 8) {
      edges {
        node {
            id
            title
            link
            content
            featuredImage
            category {
                id
                title
            }
        }
      }
    }
    interviews(limit: 4) {
      edges {
        node {
            title
            link
            source
            created
            image {
                small
            }
        }
      }
    }
  }
}
`

export default {
    props: ['page', 'parent'],
    data() {
        return {
            readOneNewsroom: {}
        }
    },
    components: {
        ArticleCard,
        VideoCard,
        PhotoAlbumCard
    },
    apollo: {
        readOneNewsroom: {
            query: readNewsroomQuery,
            variables() {
                return {
                    url: this.$route.path
                }
            },
            loadingKey: 'loading'
        }
    }
}
</script>
